import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/tools/soil-calculator/SoilCalculatorContent.tsx");
